import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, Typography, useMediaQuery, Card, CardHeader, CardContent, CardActions, CardActionArea, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider, styled, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import HomeIcon from '@mui/icons-material/Home';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import SchoolIcon from '@mui/icons-material/School';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import Grid from '@mui/material/Unstable_Grid2';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TokenContext from '../context/TokenContext'
import { actividadesAgestionar, actividadesGestionadas, confirmarOrechazarAsignacion, divisionesAgestionar, divisionesGestionadas, modificarPlanificacion, planificacionesNoPresentadas, planificacionesPresentadas } from '../Redux/asignaciones'
import { COLUMNSACTIVIDADESAGESTIONAR, COLUMNSDIVISIONESAGESTIONAR, COLUMNSPLANIFICACIONESNO } from '../columnas/columnasAsignaciones'
import TablaAsignaciones from './tablas/TablaAsignaciones'
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import TablaPlanificaciones from './tablas/TablaPlanificaciones'
import ModalPlanificacionUnificada from './modales/ModalPlanificacionUnificada'


const Asignaciones = () => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.

    const [openModal, setOpenModal] = React.useState(false);

    const [divAgestionar, setDivAgestionar] = React.useState([])
    const [loadDag, setLoadDag] = React.useState(false)
    const aGestionarSelector = useSelector(store => store.asignaciones.divisonesAgestionar)
    const loadingDagSelector = useSelector(store => store.asignaciones.loadingDaG)

    const [divGestionadas, setDivGestionadas] = React.useState([])
    const [loadDg, setLoadDg] = React.useState(false)
    const gestionadasSelector = useSelector(store => store.asignaciones.divisionesGestionadas)
    const loadingDgSelector = useSelector(store => store.asignaciones.loadingDg)

    const [actAgestionar, setActAgestionar] = React.useState([])
    const [loadAaG, setLoadAaG] = React.useState(false)
    const actAGestionarSelector = useSelector(store => store.asignaciones.actAgestionar)
    const loadingAaGSelector = useSelector(store => store.asignaciones.loadingActAg)

    const [actGestionadas, setActGestionadas] = React.useState([])
    const [loadAg, setLoadAg] = React.useState(false)
    const actGestionadasSelector = useSelector(store => store.asignaciones.actGestionadas)
    const loadingAgSelector = useSelector(store => store.asignaciones.loadingActG)

    const [planificacionesNO, setPlanificacionesNo] = React.useState([])
    const [loadingPlNO, setLoadingPlNO] = React.useState(false)
    const planificacionesNOselector = useSelector(store => store.asignaciones.planificacionesNo)
    const loadingPlNOselector = useSelector(store => store.asignaciones.loadingPlanificacionesNo)

    const [planificaciones, setPlanificaciones] = React.useState([])
    const [loadingPl, setLoadingPl] = React.useState(false)
    const planificacionesselector = useSelector(store => store.asignaciones.planificaciones)
    const loadingPlselector = useSelector(store => store.asignaciones.loadingPlanificaciones)

    const resultadoModificacion = useSelector(store => store.asignaciones.modificacion)

    const [filaPlanificacion, setFilaPlanificacion] = React.useState({})
    const [filaId, setFilaId] = React.useState('')

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(divisionesAgestionar(token, empleado.usuarioPortalRh))
            dispatch(divisionesGestionadas(token, empleado.usuarioPortalRh))
            dispatch(actividadesAgestionar(token, empleado.usuarioPortalRh))
            dispatch(actividadesGestionadas(token, empleado.usuarioPortalRh))
            dispatch(planificacionesNoPresentadas(token, empleado.usuarioPortalRh))
            dispatch(planificacionesPresentadas(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado])

    React.useEffect(() => {
        setLoadDag(loadingDagSelector)
        setLoadDg(loadingDgSelector)
        setLoadAaG(loadingAaGSelector)
        setLoadAg(loadingAgSelector)
        setLoadingPlNO(loadingPlNOselector)
        setLoadingPl(loadingPlselector)
    }, [loadingDagSelector, loadingDgSelector, loadingAaGSelector, loadingAgSelector, loadingPlNOselector, loadingPlselector])


    React.useEffect(() => {
        if (aGestionarSelector.length > 0) {
            var array = []
            aGestionarSelector.forEach(element => {
                var objeto = {
                    id: element.new_aceptaciondedivisionid,
                    new_areadisciplinar: element["division.new_areadisciplinar@OData.Community.Display.V1.FormattedValue"],
                    new_codigomateria: element["division.new_codigomateria"],
                    new_materia: element["division.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_modalidaddictado: element["division.new_modalidaddictado@OData.Community.Display.V1.FormattedValue"],
                    new_name: element["division.new_name"],
                    new_tipodedivision: element["division.new_tipodedivision@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    new_divisionid: element["division.new_divisionid"],
                    division_statuscode: element["division.statuscode@OData.Community.Display.V1.FormattedValue"],
                    divion_new_periodo: element["division.new_periodo@OData.Community.Display.V1.FormattedValue"],
                    division_new_modalidaddictado: element["division.new_modalidaddictado@OData.Community.Display.V1.FormattedValue"],
                    division_new_sede: element["division.new_sede@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setDivAgestionar(array)
        }
    }, [aGestionarSelector])

    React.useEffect(() => {
        if (gestionadasSelector.length > 0) {
            var array = []
            gestionadasSelector.forEach(element => {
                var objeto = {
                    id: element["division.new_divisionid"],
                    new_areadisciplinar: element["division.new_areadisciplinar@OData.Community.Display.V1.FormattedValue"],
                    new_codigomateria: element["division.new_codigomateria"],
                    new_materia: element["division.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_modalidaddictado: element["division.new_modalidaddictado@OData.Community.Display.V1.FormattedValue"],
                    new_name: element["division.new_name"],
                    new_tipodedivision: element["division.new_tipodedivision@OData.Community.Display.V1.FormattedValue"],
                    division_statuscode: element["division.statuscode@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setDivGestionadas(array)
        }
    }, [gestionadasSelector])

    React.useEffect(() => {
        if (actAGestionarSelector.length > 0) {
            var array = []
            actAGestionarSelector.forEach(element => {
                var objeto = {
                    id: element.new_aceptaciondedivisionid,
                    new_areadisciplinar: element["act.new_areadisciplinar@OData.Community.Display.V1.FormattedValue"],
                    new_carreras: element["act.new_carreraid@OData.Community.Display.V1.FormattedValue"],
                    new_codigomateria: element["act.new_codigomateria"],
                    new_materia: element["act.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_modalidad: element["act.new_modalidad@OData.Community.Display.V1.FormattedValue"],
                    act_new_name: element["act.new_name"],
                    new_periodo: element["act.new_periodo@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setActAgestionar(array)
        }
    }, [actAGestionarSelector])

    React.useEffect(() => {
        if (actGestionadasSelector.length > 0) {
            var array = []
            actGestionadasSelector.forEach(element => {
                var objeto = {
                    id: element["act.new_asignaciondeactividadesid"],
                    new_areadisciplinar: element["act.new_areadisciplinar@OData.Community.Display.V1.FormattedValue"],
                    new_carreras: element["act.new_carreraid@OData.Community.Display.V1.FormattedValue"],
                    new_codigomateria: element["act.new_codigomateria"],
                    new_materia: element["act.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_modalidad: element["act.new_modalidad@OData.Community.Display.V1.FormattedValue"],
                    act_new_name: element["act.new_name"],
                    new_periodo: element["act.new_periodo@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setActGestionadas(array)
        }
    }, [actGestionadasSelector])

    React.useEffect(() => {
        if (planificacionesNOselector.length > 0) {
            var array = []
            planificacionesNOselector.forEach(element => {
                var objeto = {
                    id: element.new_planificacinunificadaid,
                    new_codigomateria: element["materia.new_codigomateria"],
                    new_teamteaching: element["new_teamteaching@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_docente_value: element._new_docente_value,
                    new_docente: element["_new_docente_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    _new_matriz_value: element._new_matriz_value,
                    new_matriz: element["_new_matriz_value@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element._new_periodo_value,
                    new_periodo: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setPlanificacionesNo(array)
        }
    }, [planificacionesNOselector])

    React.useEffect(() => {
        if (planificacionesselector.length > 0) {
            var array = []
            planificacionesselector.forEach(element => {
                var objeto = {
                    id: element.new_planificacinunificadaid,
                    new_codigomateria: element["materia.new_codigomateria"],
                    new_teamteaching: element["new_teamteaching@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_docente_value: element._new_docente_value,
                    new_docente: element["_new_docente_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    _new_matriz_value: element._new_matriz_value,
                    new_matriz: element["_new_matriz_value@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element._new_periodo_value,
                    new_periodo: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setPlanificaciones(array)
        }
    }, [planificacionesselector])

    React.useEffect(() => {
        if (resultadoModificacion !== undefined) {
            if (resultadoModificacion !== '' && resultadoModificacion == "EXITO") {
                dispatch(divisionesAgestionar(token, empleado.usuarioPortalRh))
                dispatch(divisionesGestionadas(token, empleado.usuarioPortalRh))
            }
        }
    }, [resultadoModificacion])

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    const aceptarOdeclinar = (id, respuesta) => {
        dispatch(confirmarOrechazarAsignacion(token, id, respuesta))
    }

    //======|| handlers del modal planificaciones ||====== //
    const handleCloseModal = () => {
        setOpenModal(false)
        setFilaId('')
        setFilaPlanificacion({})
    };

    const handleOpenModalPlanificaciones = (id) => {
        setOpenModal(true);
        setFilaId(id)
        setFilaPlanificacion(planificacionesNO?.find((item) => item.id == id));
    };

    //submit del formulario del modal
    const handleSubmit = (objeto) => {
        if (token !== '') {
            dispatch((dispatch) => {
                dispatch(modificarPlanificacion(objeto, filaId, token))
                    .then(() => {
                        // Actualiza la tabla cuando se cumple la promesa
                        dispatch(planificacionesNoPresentadas(token, empleado.usuarioPortalRh))
                        handleCloseModal()
                    });
            });
        }
    };
    //======================================================= //

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >

                <Header title={"Asignaciones"} subtitle="En este espacio podrá Aceptar o Rechazar las asignaciones propuestas por la Universidad, así como tener la información referente a ellas." />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TabContext value={valuePrimerTab}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangePrimerTAB} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                >
                                    <Tab label="Divisiones a gestionar" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Divisiones gestionadas" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Actividades a gestionar" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Actividades gestionadas" value="4" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Planificaciones unificadas no presentadas" value="5" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Planificaciones unificadas presentadas" value="6" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                {
                                    loadDag ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : divAgestionar.length > 0 ? (
                                            <TablaAsignaciones columnas={COLUMNSDIVISIONESAGESTIONAR} lineas={divAgestionar} acciones={true} funcion={aceptarOdeclinar} tipo={"division"} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de divisiones — <strong>a gestionar</strong>.
                                            </Alert>

                                }
                            </TabPanel>
                            <TabPanel value="2">
                                {
                                    loadDg ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : divGestionadas.length > 0 ? (
                                            <TablaAsignaciones columnas={COLUMNSDIVISIONESAGESTIONAR} lineas={divGestionadas} acciones={false} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de divisiones — <strong>gestionadas</strong>.
                                            </Alert>

                                }
                            </TabPanel>
                            <TabPanel value="3">
                                {
                                    loadAaG ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : actAgestionar.length > 0 ? (
                                            <TablaAsignaciones columnas={COLUMNSACTIVIDADESAGESTIONAR} lineas={actAgestionar} acciones={true} funcion={aceptarOdeclinar} tipo={"actividad"} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de actividades — <strong>a gestionar</strong>.
                                            </Alert>

                                }
                            </TabPanel>
                            <TabPanel value="4">
                                {
                                    loadAg ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : actGestionadas.length > 0 ? (
                                            <TablaAsignaciones columnas={COLUMNSACTIVIDADESAGESTIONAR} lineas={actGestionadas} acciones={false} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de actividades — <strong>gestionadas</strong>.
                                            </Alert>

                                }
                            </TabPanel>
                            <TabPanel value="5">
                                {
                                    loadingPlNO ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : planificacionesNO.length > 0 ? (
                                            <TablaPlanificaciones columnas={COLUMNSPLANIFICACIONESNO} lineas={planificacionesNO} handleOpen={handleOpenModalPlanificaciones} acciones={true} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de planificaciones unificadas — <strong>no presentadas</strong>.
                                            </Alert>

                                }
                            </TabPanel>
                            <TabPanel value="6">
                                {
                                    loadingPl ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    )
                                        : planificaciones.length > 0 ? (
                                            <TablaAsignaciones columnas={COLUMNSPLANIFICACIONESNO} lineas={planificaciones} acciones={false} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                Aún no tienes registros de planificaciones unificadas — <strong>presentadas</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Box>
            <ModalPlanificacionUnificada open={openModal} handleClose={handleCloseModal} asignacion={filaPlanificacion} asignacionId={filaId} onSubmit={handleSubmit} />
        </motion.div>
    )
}

export default Asignaciones